import { isDefined } from '@sgme/fp';
import { FormattedDate } from 'react-intl';

import { useAlgoTileId } from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoNDFFixingDate } from '@/store/orders/algoOrders/selectors.ts';

const AlgoNDFFixingDate = () => {
  const tileId = useAlgoTileId();
  const ndfFixingDate = useAppSelector((state) => selectAlgoNDFFixingDate(state, tileId));

  return (
    isDefined(ndfFixingDate) && (
      <OrderRow labelId="order.fields.fixingDate">
        <span className="fs-12">
          <FormattedDate value={ndfFixingDate} year="numeric" month="short" day="2-digit" timeZone="UTC" />
        </span>
      </OrderRow>
    )
  );
};

export default AlgoNDFFixingDate;
